import { createContext } from "react";

export const PageSizeContext = createContext();